module.exports = __webpack_public_path__ + "img/am.8fc11bc3.jpeg";